import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      icon: 'Shield',
      title: 'SSL Secured',
      description: 'Bank-level encryption'
    },
    {
      icon: 'Award',
      title: 'SOC 2 Compliant',
      description: 'Audited security standards'
    },
    {
      icon: 'Lock',
      title: 'GDPR Compliant',
      description: 'Privacy protection'
    },
    {
      icon: 'CheckCircle',
      title: '99.9% Uptime',
      description: 'Reliable service'
    }
  ];

  const testimonials = [
    {
      name: 'Sarah Chen',
      role: 'Professional Trader',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face',
      content: `CryptoPredict Pro's AI predictions helped me increase my portfolio by 340% in just 6 months. The accuracy is incredible!`,
      rating: 5
    },
    {
      name: 'Michael Rodriguez',role: 'Investment Advisor',avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face',content: `I've been using this platform for my clients' crypto investments. The risk assessment tools are game-changing.`,
      rating: 5
    },
    {
      name: 'Emily Johnson',role: 'Crypto Enthusiast',avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face',
      content: `As a beginner, the educational content and clear signals made crypto trading accessible and profitable for me.`,
      rating: 5
    }
  ];

  const stats = [
    {
      value: '50K+',
      label: 'Active Traders',
      icon: 'Users'
    },
    {
      value: '94%',
      label: 'Prediction Accuracy',
      icon: 'Target'
    },
    {
      value: '$2.1B+',
      label: 'Trading Volume',
      icon: 'TrendingUp'
    },
    {
      value: '24/7',
      label: 'Market Coverage',
      icon: 'Clock'
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Icon
        key={i}
        name="Star"
        size={14}
        className={i < rating ? 'text-accent fill-current' : 'text-muted-foreground'}
      />
    ));
  };

  return (
    <div className="space-y-12">
      {/* Trust Badges */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-4 text-center">
          Trusted & Secure Platform
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustBadges?.map((badge, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <Icon name={badge?.icon} size={24} className="text-primary" />
              </div>
              <h4 className="font-medium text-card-foreground text-sm">{badge?.title}</h4>
              <p className="text-xs text-muted-foreground">{badge?.description}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Statistics */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-4 text-center">
          Platform Statistics
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <Icon name={stat?.icon} size={24} className="text-secondary" />
              </div>
              <div className="text-2xl font-bold text-card-foreground">{stat?.value}</div>
              <div className="text-sm text-muted-foreground">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Testimonials */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-6 text-center">
          What Our Users Say
        </h3>
        <div className="space-y-6">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="border-b border-border last:border-b-0 pb-6 last:pb-0">
              <div className="flex items-start space-x-4">
                <img
                  src={testimonial?.avatar}
                  alt={testimonial?.name}
                  className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                  onError={(e) => {
                    e.target.src = '/assets/images/no_image.png';
                  }}
                />
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <h4 className="font-medium text-card-foreground">{testimonial?.name}</h4>
                    <span className="text-sm text-muted-foreground">•</span>
                    <span className="text-sm text-muted-foreground">{testimonial?.role}</span>
                  </div>
                  <div className="flex items-center space-x-1 mb-2">
                    {renderStars(testimonial?.rating)}
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    "{testimonial?.content}"
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Social Proof */}
      <div className="text-center">
        <div className="flex items-center justify-center space-x-8 text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Award" size={16} />
            <span className="text-sm">Featured in TechCrunch</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Star" size={16} />
            <span className="text-sm">4.9/5 on Trustpilot</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={16} />
            <span className="text-sm">50K+ Happy Users</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;